import PropTypes from 'prop-types'

const FlagEN = ({ width = '20', height = '20', className = '', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 40"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Blue background */}
    <rect width="60" height="40" fill="#012169" />
    {/* White diagonals */}
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8" />
    {/* Red diagonals */}
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="5" />
    {/* White cross */}
    <path d="M30,0 V40 M0,20 H60" stroke="#fff" strokeWidth="13" />
    {/* Red cross */}
    <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="8" />
  </svg>
)

FlagEN.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

export default FlagEN
